import { render, staticRenderFns } from "./DetailNav.vue?vue&type=template&id=c5bed28a&scoped=true"
import script from "./DetailNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailNav.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailNav.vue?vue&type=style&index=0&id=c5bed28a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bed28a",
  null
  
)

export default component.exports